import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { Page404Component } from './features/authentication/page404/page404.component';
import { HomepageComponent } from './features/portal-carta-servico/homepage/homepage.component';
import { PagesServicosComponent } from './features/portal-carta-servico/pages-servicos/pages-servicos.component';
import { PageCategoriaServicosComponent } from './features/portal-carta-servico/page-categoria-servicos/page-categoria-servicos.component';
import { ServicosDigitaisComponent } from './features/portal-carta-servico/servicos-digitais/servicos-digitais.component';
import { TodosServicosComponent } from './features/portal-carta-servico/todos-servicos/todos-servicos.component';
import { SigninComponent } from './features/authentication/signin/signin.component';
import { CadastroComponent } from './features/portal-carta-servico/perfil-usuario/cadastro/cadastro.component';
import { ResultadoBuscaComponent } from './features/portal-carta-servico/resultado-busca/resultado-busca.component';
import { AreaCidadaoComponent } from './features/portal-carta-servico/perfil-usuario/area-cidadao/area-cidadao.component';
import { AcompanharSolicitacaoDeslogadoComponent } from './features/portal-carta-servico/perfil-usuario/acompanhar-solicitacao-deslogado/acompanhar-solicitacao-deslogado.component';
import { PagesPerguntasPoliticaCanaisComponent } from './features/portal-carta-servico/pages-perguntas-politica-canais/pages-perguntas-politica-canais.component';
import { CanalBlocoComponent } from './features/portal-carta-servico/pages-perguntas-politica-canais/canal-bloco/canal-bloco.component';
import { LgpdComponent } from './features/portal-carta-servico/lgpd/lgpd.component';
import { TodasNoticiasComponent } from './features/portal-carta-servico/noticia/todas-noticias/todas-noticias.component';
import { NoticiaComponent } from './features/portal-carta-servico/noticia/noticia.component';
import { OuvidoriaComponent } from './features/portal-carta-servico/ouvidoria/ouvidoria.component';
import { EstatisticasOuvidoriaComponent } from './features/portal-carta-servico/ouvidoria/estatisticas-ouvidoria/estatisticas-ouvidoria.component';
import { OuvidoriaPresencialComponent } from './features/portal-carta-servico/ouvidoria/ouvidoria-presencial/ouvidoria-presencial.component';
import { ManifestacaoComponent } from './features/portal-carta-servico/ouvidoria/manifestacao/manifestacao.component';
import { SicComponent } from './features/portal-carta-servico/sic/sic.component';
import { PedidoInformacaoComponent } from './features/portal-carta-servico/sic/pedido-informacao/pedido-informacao.component';
import { EstatisticasSicComponent } from './features/portal-carta-servico/sic/estatisticas-sic/estatisticas-sic.component';
import { SicPresencialComponent } from './features/portal-carta-servico/sic/sic-presencial/sic-presencial.component';
import { authInverseGuard } from './core/guards/auth-inverse/auth-inverse.guard';
import { authTokenGuard } from './core/guards/auth-token/auth-token.guard';
import { servicoExisteGuard } from './core/guards/servico-existe/servico-existe.guard';

const routes: Routes = [ 
  {
    path: 'authentication',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./features/authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      { path: '', redirectTo: 'homepage', pathMatch: 'full' },
      { path: 'homepage', component: HomepageComponent },
      { path: 'categorias-servicos', component: PageCategoriaServicosComponent },
      { path: 'servicos-digitais', component: ServicosDigitaisComponent },
      { path: 'servicos', component: TodosServicosComponent },
      { path: 'servicos/:categoria', component: TodosServicosComponent },
      { path: 'login', canActivate: [authInverseGuard], component: SigninComponent },
      { path: 'cadastro', component: CadastroComponent },
      { path: 'resultado-busca', component: ResultadoBuscaComponent },
      { path: 'area-cidadao', canActivate: [authTokenGuard], component: AreaCidadaoComponent },
      { path: 'acompanhamento', component: AcompanharSolicitacaoDeslogadoComponent },
      {
        path: 'outros-canais-atendimento',
        component: PagesPerguntasPoliticaCanaisComponent,
        data: { pagina: 'canais' },
      },
      { path: 'outros-canais-atendimento/:canal/:bloco', component: CanalBlocoComponent },
      {
        path: 'perguntas-frequentes',
        component: PagesPerguntasPoliticaCanaisComponent,
        data: { pagina: 'perguntas' },
      },
      {
        path: 'politica-atendimento',
        component: PagesPerguntasPoliticaCanaisComponent,
        data: { pagina: 'politica' },
      },
      { path: 'noticias', component: TodasNoticiasComponent },
      { path: 'noticias/:id', component: NoticiaComponent },
      { path: 'lgpd', component: LgpdComponent },
      { path: 'ouvidoria', component: OuvidoriaComponent },
      { path: 'estatisticas-ouvidoria', component: EstatisticasOuvidoriaComponent },
      { path: 'ouvidoria/presencial', component: OuvidoriaPresencialComponent },
      { path: 'ouvidoria/:tipo', component: ManifestacaoComponent },
      { path: 'sic', component: SicComponent },
      { path: 'sic/pedido', component: PedidoInformacaoComponent },
      { path: 'sic/estatisticas', component: EstatisticasSicComponent },
      { path: 'sic/presencial', component: SicPresencialComponent },
      // Curinga de serviço: só casa quando a rota existe de fato, senão cai no 404 abaixo.
      { path: ':rotaPagina', canMatch: [servicoExisteGuard], component: PagesServicosComponent },
      { path: '**', component: Page404Component },
    ],
  },
  { path: '**', component: Page404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // Toda rota abre do topo; a rolagem em si não é animada (ver `scroll-behavior` em css/styles.css).
    scrollPositionRestoration: 'top',
    anchorScrolling: 'disabled',
    bindToComponentInputs: true,
  }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
